export function isObject(item: any): item is Record<string, any> {
  return item !== null && typeof item === 'object' && !Array.isArray(item)
}

export function deepmerge<T = any, U = any>(
  target: T,
  source: U,
  options: { clone?: boolean } = { clone: true }
): T & U {
  const output: any =
    options.clone !== false ? (Array.isArray(target) ? [...target] : isObject(target) ? { ...target } : target) : target

  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(key => {
      const targetValue = (target as any)[key]
      const sourceValue = (source as any)[key]

      if (isObject(targetValue) && isObject(sourceValue)) {
        output[key] = deepmerge(targetValue, sourceValue, options)
      } else if (sourceValue !== undefined) {
        output[key] = sourceValue
      }
    })
  }

  return output
}

export const visuallyHidden = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute' as const,
  whiteSpace: 'nowrap' as const,
  width: '1px'
}

export default deepmerge
